/**
 * Created by vladislav on 1/18/2024
 */

const PlatformLogic = function () {
    if (connector.info.isNative && !connector.platform.oneOf(connector.WECHAT)) {
        const params = new URLSearchParams(window.location.search);
        if (params.has("source")) {
            cc.sys.isNativeFlight = true;
        }
    }

    connector.payments.on("stream:logs", this.logEvent.bind(this));
    connector.social.on("stream:logs", this.logEvent.bind(this));
    connector.ads.on("stream:logs", this.logEvent.bind(this));
    connector.platform.on("stream:logs", this.logEvent.bind(this));

    connector.payments.on("stream:error", this.throwError.bind(this));
    connector.social.on("stream:error", this.throwError.bind(this));
    connector.ads.on("stream:error", this.throwError.bind(this));
    connector.platform.on("stream:error", this.throwError.bind(this));

    connector.payments.on("stream:debug", this.showDebugNotification.bind(this));
    connector.social.on("stream:debug", this.showDebugNotification.bind(this));
    connector.ads.on("stream:debug", this.showDebugNotification.bind(this));
    connector.platform.on("stream:debug", this.showDebugNotification.bind(this));

    connector.payments.on("stream:console", this.consoleStream.bind(this));
    connector.social.on("stream:console", this.consoleStream.bind(this));
    connector.ads.on("stream:console", this.consoleStream.bind(this));
    connector.platform.on("stream:console", this.consoleStream.bind(this));

    connector.notifications.on("stream:error", this.throwError.bind(this));
    connector.notifications.on("stream:logs", this.logEvent.bind(this));
    connector.notifications.on("pushClicked", this.logClickEvent.bind(this));
    connector.notifications.on("pushSent", (push) => {
        if (connector.notifications.isClientSender()) {
            cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.PUSHES.SEND + push.code);
        }
    });
};

PlatformLogic.prototype.logEvent = function (name, params) {
    cleverapps.metrics.logEvent(name, params);
};

PlatformLogic.prototype.throwError = function (messages, error) {
    cleverapps.throwAsync(messages, error);
};

PlatformLogic.prototype.showDebugNotification = function (message) {
    if (cleverapps.config.debugMode) {
        cleverapps.notification.create(message);
    }
};

PlatformLogic.prototype.consoleStream = function (group, ...messages) {
    cleverapps.ConsoleStream.sendMessages(group, cleverapps.ConsoleStream.serialize([...messages]));
};

PlatformLogic.prototype.onInitialize = function () {

};

PlatformLogic.prototype.onStart = function () {

};

PlatformLogic.prototype.initGameEvents = function () {
    cleverapps.inputDispatcher.initialize(cc.game.canvas);

    cleverapps.inputDispatcher.onUnhandledTouchListener = (touch) => {
        cleverapps.UI.createTapAnimation(touch);
        cleverapps.eventBus.trigger("unhandledTouch");
    };

    cleverapps.inputDispatcher.on("keyreleased", (keyCode) => {
        if (keyCode === InputDispatcher.KEY.escape) {
            ReturnAction();
        }
    });

    connector.platform.on("backButtonPressed", ReturnAction);

    // Resume audio context after clicks (after autoplay policy pause; after alerts)
    // Use HTML5 pointerdown event instead of cc.eventManager touch listener
    const resumeAudioOnClick = cleverapps.accumulate(100, () => {
        cleverapps.audio && cleverapps.audio.resumeAudioContext();
    });
    cc.game.canvas.addEventListener("pointerdown", resumeAudioOnClick);
};

PlatformLogic.prototype.logClickEvent = function (code) {
    cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.PUSHES.CLICK + code);

    if (cleverapps.config.debugMode) {
        cleverapps.timeouts.setTimeout(() => {
            cleverapps.notification.create(`Source Push: ${code}`);
        }, 5000);
    }
};

PlatformLogic.isTmpId = function (id) {
    return id && id.startsWith("__");
};

PlatformLogic.isDeviceId = function (id) {
    const deviceId = connector.info.deviceID;

    return deviceId && id === deviceId;
};

PlatformLogic.create = function () {
    const platforms = {
        wechat: WechatLogic,
        ios: AppleLogic,
        macos: AppleLogic,
        instant: InstantLogic,
        msstart: MSStartLogic,
        ok: OKLogic,
        vk: VKLogic,
        yandex: YandexLogic,
        microsoft: MicrosoftLogic,
        kongregate: KongregateLogic,
        cleverapps: CleverAppsLogic,
        labsystech: LabSysTechLogic,
        crazy: CrazyLogic,
        gdcom: GDComLogic,
        coolmath: CoolMathGamesLogic,
        mbga: MobageLogic,
        sp_mbga: SPMobageLogic,
        youtube: YoutubeLogic,
        gamesnack: GameSnackLogic,
        fotostrana: FotostranaLogic,
        samsung: SamsungLogic,
        arkadium: ArkadiumLogic
    };

    let source = connector.info.source;
    if (source === "ok" && connector.config.ok && connector.config.ok.bridge) {
        source = "vk";
    }
    const Class = platforms[source] || PlatformLogic;

    return new Class();
};

cc.sys.LANGUAGE_LATVIAN = "lv";
cc.sys.LANGUAGE_TURKISH = "tr";
cc.sys.LANGUAGE_DUTCH = "nl";
